import React from "react";
import { goToCheckout, IMAGES, PRICE } from "../src/config";
export function Header() {
  return <header className="relative z-30 w-full border-b border-white/5 bg-[#0a0a1f]/80 backdrop-blur" data-id="element-125" data-mp="2dll00z8ot8m1">
      <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6" data-id="element-126" data-mp="2il7mlzaeo17i">
        <div className="flex items-center gap-2" data-id="element-127" data-mp="2nku26fdphtjh">
          <img src={IMAGES.logo} alt="Nexto Digital" className="h-9 w-auto object-contain" style={{
          maxWidth: 150
        }} data-id="element-128" data-mp="2nih8x62hzwr4" />
        </div>
        <button onClick={goToCheckout} className="rounded-full bg-violet-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-violet-500" data-id="element-129" data-mp="2wjfi02rsmugk">
          Acceso {PRICE}
        </button>
      </div>
    </header>;
}